export default "__VITE_ASSET__D1iqJj1S__"